import {createContext} from 'react'
import type {UserSettings} from '@package/shared'
import type {UpdateUserSettingsRequest} from '@app/api-resolver/router'

type Context = {
  userSettings: UserSettings
  loading: boolean

  updateUserSettings: (request: UpdateUserSettingsRequest) => Promise<void>
}

export const UserSettingsContext = createContext<Context>({} as Context)
